import { render, staticRenderFns } from "./redEnvelopeRainPageFloatIcon.vue?vue&type=template&id=7555f20a&scoped=true"
import script from "./redEnvelopeRainPageFloatIcon.vue?vue&type=script&lang=js"
export * from "./redEnvelopeRainPageFloatIcon.vue?vue&type=script&lang=js"
import style0 from "./redEnvelopeRainPageFloatIcon.vue?vue&type=style&index=0&id=7555f20a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7555f20a",
  null
  
)

export default component.exports